import { AxiosInstance } from "axios";
import { authInterceptor } from "./auth-interceptor";
import { errorInterceptor } from "./error-interceptor";
import { multipartInterceptor } from "./multipart-interceptor";
import { queryInterceptor } from "./query-interceptor";
import { successInterceptor } from "./success-interceptor";

export const setupInterceptors = (instance: AxiosInstance) => {
  // Ordem importante: request primeiro, response depois
  instance.interceptors.request.use(queryInterceptor);
  instance.interceptors.request.use(authInterceptor);
  instance.interceptors.request.use(multipartInterceptor);

  instance.interceptors.response.use(successInterceptor, errorInterceptor);

  return instance;
};
